export var SkeletonTypes;
(function (SkeletonTypes) {
    SkeletonTypes["ROUNDED_RECTANGLE"] = "rounded_rectangle";
    SkeletonTypes["RECTANGLE"] = "rectangle";
    SkeletonTypes["CIRCLE"] = "circle";
})(SkeletonTypes || (SkeletonTypes = {}));
//# sourceMappingURL=Skeleton.types.js.map